import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'underscore';
import Modal from 'react-responsive-modal';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import {Link} from 'react-router-dom';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('DOCUMENT_DETAILS', LOG_LEVELS.DEBUG);

class DocumentDetails extends Component {

  constructor(props) {
    super(props);
    this.state = ({open: props.open});
    this.onCloseModal = this.onCloseModal.bind(this);
    log.debug('constructor(): ', this.state);
  
  }

  onCloseModal() {
    this.setState({open: false});
    log.debug('onCloseModal(): ', this.state);
    this.props.onClose();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    log.debug('componentWillReceiveProps(): ', nextProps);
    //this.setState({open: true});
    log.debug('componentWillReceiveProps(): ', this.state);
  }

  render() {
    log.debug('render(): ', this.props, this.state);
    const documentDetails = this.props.documentDetails || {};
    log.debug('details: ', documentDetails);
    if (_.isEmpty(documentDetails)) {
      return (<div></div>);
    }

    let formatFloatValue = (floatValue) => {
      const parsedValue = parseFloat(floatValue);
      return typeof parsedValue === 'number' ? parsedValue.toFixed(2) : floatValue;
    };

    const MODAL_CLASSNAMES =  {
      modal: 'modal-full-width-height modal-max-width-85 pb0'
    };

    return (
      <div>
        <Modal
          open={this.props.open}
          onClose={this.onCloseModal.bind(this)}
          classNames={MODAL_CLASSNAMES}>
          <h2>
            <LanguageStringResolver string="documentDetails_Header" />
          </h2>
          <div className="overflow-auto">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th><LanguageStringResolver string="documentDetails_InvoiceNr" /></th>
                  <th><LanguageStringResolver string="documentDetails_SuppInvoiceNr" /></th>
                  <th><LanguageStringResolver string="documentDetails_TransDt" /></th>
                  <th><LanguageStringResolver string="documentDetails_Company" /></th>
                  <th><LanguageStringResolver string="documentDetails_Currency" /></th>
                  <th><LanguageStringResolver string="documentDetails_TotalVal" /></th>
                  <th><LanguageStringResolver string="documentDetails_Message" /></th>
                </tr>
              </thead>
              <tbody>
              {

                (() => {
                  if (documentDetails.details <= 0) {
                    return (<tr>
                      <td colSpan={10}><LanguageStringResolver string="documentDetails_NoValues"/></td>
                    </tr>)
                  }

                  return documentDetails.map((detail, index) => (

                    <tr className={detail.errorMessage ? 'error' : ''} key={index}>
                      <td>{index + 1}</td>
                      <td>
                        {detail.errorMessage ? detail.invoiceNumber :
                          <Link to={'/TransactionSearch?exactMatch&reference=' + detail.documentId + '&searchType=1&year=' + (detail.transactionDate+'').substring(0, 4)}>{detail.invoiceNumber}</Link>
                        }</td>
                      <td>{detail.supplierInvoiceNumber}</td>
                      <td>{detail.transactionDate}</td>
                      <td>{detail.company}</td>
                      <td>{detail.currency}</td>
                      <td className="text-align-right">
                        {detail.errorMessage ? '' : formatFloatValue(detail.totalValue)}</td>
                      <td>{detail.errorMessage}</td>
                    </tr>
                  ))

                })()
              }
              </tbody>
            </table>
          </div>
        </Modal>
      </div>
    );
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {

  return {};
}


DocumentDetails.defaultProps = {
  open: false
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(DocumentDetails);
